import { useQuery } from '@tanstack/react-query';
import {
  GetListPointTransactionEntity,
  InqueryTpbStatementEntity,
  UserWalletTransactionService,
} from 'services/openapi';

import { isEmpty } from 'lodash';
import { AccountTPBankQueryKeys } from './constants';

type GetListTransPointDTO = {
  fromTime: string;
  toTime: string;
  accountNumber: string;
  page: string;
  pageSize: string;
};

export const useGetTransactionsOfAccountTPBankQuery = (
  variables: GetListTransPointDTO,
) => {
  const queryKey = [AccountTPBankQueryKeys.GET_TRANSACTIONS, variables];

  const {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  } = useQuery<InqueryTpbStatementEntity, Error>({
    queryKey,
    queryFn: () =>
      UserWalletTransactionService.transactionControllerInqueryTpbStatement(
        variables.fromTime?.trim(),
        variables.toTime?.trim(),
        variables.page,
        variables.pageSize,
        variables.accountNumber,
      ),
    retry: 0,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    enabled: !isEmpty(variables) && !!variables.accountNumber,
  });

  return {
    isLoading,
    isLoadingError,
    isFetching,
    error,
    data: data,
    isError,
    queryKey,
    refetch,
  };
};
